import { Offer } from '@funtech-int/yango-shared';

import { PlusPaymentPlace } from '@/shared/constants/payments';

export const getAnnualPrice = (price?: number) => {
    if (!price || Number.isNaN(price)) return;

    const divided = price / 12;
    const integerPart = Math.floor(divided);
    const hasFractionalPart = divided % 1 !== 0;
    const isSingleDigit = integerPart >= 0 && integerPart <= 9;
    if (hasFractionalPart && isSingleDigit) {
        const roundedToTenths = Math.round(divided * 10) / 10;
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        }).format(roundedToTenths);
    }
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Math.round(divided));
};

const MULTI_OFFER_TABS = ['base', 'extra'] as const;
type MultiOfferTab = (typeof MULTI_OFFER_TABS)[number];

const PLACES_BY_TAB: Record<MultiOfferTab, PlusPaymentPlace> = {
    base: PlusPaymentPlace.PaywallBaseOfferButton,
    extra: PlusPaymentPlace.PaywallExtraOfferButton,
};

export const getMultiOfferTabByPlace = (place: PlusPaymentPlace | undefined) =>
    place === PlusPaymentPlace.PaywallExtraOfferButton ? 'extra' : 'base';

const isMultiOfferTab = (tab: string | null): tab is MultiOfferTab =>
    tab !== null && (MULTI_OFFER_TABS as readonly string[]).includes(tab);

export const getPlaceByMultiOfferTab = (tabId: string | null) => {
    const candidate = isMultiOfferTab(tabId) ? tabId : 'base';

    return PLACES_BY_TAB[candidate] ?? PLACES_BY_TAB.base;
};

export const getOfferTabId = (offer: Offer | undefined): string =>
    offer?.offerTexts?.customTexts?.tabId ?? '';

export const getEmptyOffer = (sessionId?: string): Offer =>
    ({
        eventSessionId: sessionId ?? '',
        offerToken: '',
        analyticData: {},
        position: undefined,
        target: '',
        offerTexts: {},
        catalogCompositeOffer: {},
        legalInfo: {},
        purchaseToken: '',
        place: '',
        requestedFeatures: [],
        oneClickAvailable: undefined,
        widgetSelector: undefined,
        pmsId: '',
        pmsOffersConfigurationIds: [],
    } as unknown as Offer);
